import request from '@apps-common/js-client/api/request';
import {API_BASE_URL, REPORTS_API_BASE_PATH} from '@account/config';

request.defaults.baseURL = API_BASE_URL;

export const getReceipts = ({
  orgId,
  planId,
  url,
  reportType,
  cadence,
  start,
  end,
}) => {
  const params = {
    org_id: orgId,
    plan_id: planId,
    report_type: reportType,
    cadence,
    start,
    end,
  };

  return request
    .get(url || `${REPORTS_API_BASE_PATH}/`, {params})
    .then(res => res.data);
};

export const getPVReceipts = ({
  orgId,
  planId,
  lineItemId,
  url,
  reportType,
  cadence,
  start,
  end,
}) => {
  const params = {
    org_id: orgId,
    plan_id: planId,
    line_item_id: lineItemId,
    report_type: reportType,
    cadence,
    start,
    end,
  };

  return request
    .get(url || `${REPORTS_API_BASE_PATH}/pv/`, {params})
    .then(res => res.data);
};
